import { notification } from 'antd'
import { useQuery } from 'react-query'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@api'

import { getConfDataApi } from './api'

const useGetConfigurationsData = () => {
  const { t } = useTranslation()
  const onError = () => {
    notification.error({
      message: t('globals.admin_router.admin_dashboard.settings.get_error'),
    })
  }
  const { data, isLoading } = useQuery([QUERY_KEYS.CONFIGURATIONS], getConfDataApi.getConfData, {
    onError,
  })

  return {
    dataConfiguration: data,
    isLoading,
  }
}

export { useGetConfigurationsData }
